import React from 'react';

import { Icon, type IconName } from '../Icon/Icon';
import { Root, TabLabel, Count, TabMaskIcon, BADGE_COLORS, type BadgeColor } from './Tab.styles';

export type { BadgeColor };

export type TabProps = {
  id: string;
  label: string;
  /** Optional leading icon (before the label), following the tab's active/idle colour. */
  icon?: IconName;
  /** Alternative to `icon`: a remote monochrome glyph URL (e.g. a studio menu icon), masked + tinted
   *  to the tab colour. Takes precedence over `icon`. */
  iconSrc?: string;
  count?: number;
  badgeColor?: BadgeColor;
  active: boolean;
  /** Receives the tab `id` via `event.currentTarget.dataset.id`. */
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
};

/** Pill tab with an optional leading icon and count badge — used by the campaigns browser. */
export const Tab = ({ id, label, icon, iconSrc, count, badgeColor = 'muted', active, onClick }: TabProps): React.ReactElement => {
  const badge = BADGE_COLORS[badgeColor];
  return (
    <Root type="button" $active={active} data-id={id} onClick={onClick}>
      {iconSrc ? <TabMaskIcon $src={iconSrc} aria-hidden="true" /> : icon ? <Icon name={icon} size={16} /> : null}
      <TabLabel text={label} tag="span" />
      {count != null ? (
        <Count $bg={badge.bg} $fg={badge.fg}>
          {count}
        </Count>
      ) : null}
    </Root>
  );
};

export default Tab;